import { render, staticRenderFns } from "./tertiary.vue?vue&type=template&id=edc33716&"
import script from "./tertiary.vue?vue&type=script&lang=js&"
export * from "./tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports